import { useEffect, useRef } from 'react';

import { API_BASE_URL } from '../utils/constants';

type MaintenanceMode = 'none' | 'comprehensive' | 'bot_only' | 'website_only';

interface UseMaintenancePollingOptions {
  onMaintenanceChange: (mode: MaintenanceMode, message: string | null) => void;
  interval?: number;
  enabled?: boolean;
}

export function useMaintenancePolling({ onMaintenanceChange, interval = 8000, enabled = true }: UseMaintenancePollingOptions) {
  const savedCallback = useRef(onMaintenanceChange);
  savedCallback.current = onMaintenanceChange;

  useEffect(() => {
    if (!enabled) return;

    let active = true;
    let timeoutId: ReturnType<typeof setTimeout>;

    const poll = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/maintenance/status`);
        const data = await res.json();
        if (!active) return;
        const mode: MaintenanceMode = data?.data?.maintenance?.mode || 'none';
        const message: string | null = data?.data?.maintenance?.message || null;
        savedCallback.current(mode, message);
      } catch {
        // ignore polling errors
      }
      if (active) {
        timeoutId = setTimeout(poll, interval);
      }
    };

    poll();

    return () => {
      active = false;
      clearTimeout(timeoutId);
    };
  }, [interval, enabled]);
}
